export const VarName = {
    Bateria: 'Bateria',
    Movimiento: 'Movimiento',
    Temperatura: 'Temperatura',
    Humedad:'Humedad',
    Magnetico:'Magnetico',
    Latitud: 'Latitud',
    Longitud: 'Longitud'
}
export const VarType = {
    Numerico : 'number', // valor expresado en numero y en string de entrada
    Booleano: 'boolean', // valor expresado en numerico 0 y 1
    String: 'string', // valor expresado como cadena formato default
}